import { useLocalSessionId } from '@daily-co/daily-react'
import { DailyVideoSession } from './DailyVideoSession'

export function LocalVideo() {
  const sessionId = useLocalSessionId()
  return <DailyVideoSession sessionId={sessionId} mirror className='!object-cover' />
}
